import { Link, useRouterState } from '@tanstack/react-router'
import { Activity, Kanban, Clock, Bell, User } from 'lucide-react'
import { useUIStore } from '@/stores/uiStore'

const TABS = [
  { to: '/monitoring', label: 'Monitor',  icon: Activity },
  { to: '/planning',   label: 'Projects', icon: Kanban   },
  { to: '/time',       label: 'Time',     icon: Clock    },
  { to: '/inbox',      label: 'Inbox',    icon: Bell     },
]

export default function BottomTabBar() {
  const pathname             = useRouterState({ select: (s) => s.location.pathname })
  const { setMobileNavOpen } = useUIStore()
  const isActive = (to: string) => pathname.startsWith(to)

  return (
    <nav className="bottom-tab-bar">
      {TABS.map(({ to, label, icon: Icon }) => (
        <Link
          key={to}
          to={to as '/monitoring' | '/planning' | '/time'}
          className={`bottom-tab${isActive(to) ? ' active' : ''}`}
        >
          <Icon size={20} />
          <span>{label}</span>
        </Link>
      ))}
      <button
        className="bottom-tab"
        onClick={() => setMobileNavOpen(true)}
        style={{ background: 'none', border: 'none' }}
      >
        <User size={20} />
        <span>Me</span>
      </button>
    </nav>
  )
}
